import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Status } from '../_models/status';
import { MessService } from '../_services/mess-service.service';
import { StatusService } from '../_services/status.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
})
export class StatusComponent implements OnInit, OnDestroy {
  loading: boolean = true;

  allStatus: Status[];
  allStatusSub: Subscription;

  subscriptions: Subscription[] = [];

  constructor(
    private messService: MessService,
    private statusService: StatusService,
    private confirmationService: ConfirmationService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.updateStatusList();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // * Edit/Delete === //
  onEditStatus(statusData: Status) {
    this.statusService.updateStatusData.next(statusData);
  }

  onDeleteStatus(event, statusId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete status?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.statusService.deleteStatus(statusId).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Obrisali ste status.',
              });
              this.updateStatusList();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }

  // * Update list after delete === //
  private updateStatusList() {
    this.loading = true;
    this.subscriptions.push(
      this.statusService.getAllStatus().subscribe((responseData: Status[]) => {
        this.allStatus = responseData;
        this.loading = false;
      })
    );
  }
}
